import * as BABYLON from 'babylonjs';
import Vec3 from '../../../shared/vec3';
import LoadingScreen from "../overlay/LoadingScreen";

export interface Asset {
    id: string,
    directory: string,
    fileName: string,
}

export interface ModelAsset extends Asset {
    scaling: Vec3
}

export interface AssetList {
    models: Array<ModelAsset>,
    sounds: Array<Asset>
}

class AssetLoader {

    scene: BABYLON.Scene;
    assetsManager: BABYLON.AssetsManager;

    models: {
        [id: string]: BABYLON.AbstractMesh
    } = {};
    sounds: {
        [id: string]: BABYLON.Sound
    } = {};

    finishCallback: () => void = () => {};

    constructor(scene: BABYLON.Scene) {
        this.scene = scene;
        this.assetsManager = new BABYLON.AssetsManager(scene);

        this.assetsManager.useDefaultLoadingScreen = false;
        this.assetsManager.onProgress = (remainingCount: number, totalCount: number) => {
            const percentage = totalCount > 0 ? (totalCount-remainingCount) / totalCount : 1.0;
            const percentageInt = Math.floor(100 * percentage);
            LoadingScreen.update(percentageInt);
        };
    }

    onFinish(finishCallback: () => void) {
        this.finishCallback = finishCallback;
    }

    loadAssets(assetList: AssetList) {
        assetList.models.forEach(model => {
            console.log('Loading model asset', model.fileName);
            this.assetsManager.addMeshTask(model.id.toString(), "", model.directory, model.fileName).onSuccess = (task) => {
                this.models[model.id] = task.loadedMeshes[0];
                this.models[model.id].scaling = model.scaling.toBabylonVector3();
                this.models[model.id].setEnabled(false);
            }
        })

        assetList.sounds.forEach(sound => {
            console.log('Loading sound asset', sound.fileName);
            this.assetsManager.addBinaryFileTask(sound.id.toString(), `${sound.directory}${sound.fileName}`).onSuccess = (task) => {
                this.sounds[sound.id] = new BABYLON.Sound(sound.id.toString(), task.data, this.scene, null, {});
            }
        })

        this.assetsManager.onFinish = () => {
            console.log('Finished loading assets', this.models);
            LoadingScreen.hide();
            this.finishCallback();
        }

        this.assetsManager.load();
    }

    disposeAllModels() {
        Object.values(this.models).forEach(model => model.dispose());
    }
}

export default AssetLoader;
